import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const List20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.5 1.25C0.809644 1.25 0.25 1.80964 0.25 2.5V7.5C0.25 8.19036 0.809644 8.75 1.5 8.75H6.5C7.19036 8.75 7.75 8.19036 7.75 7.5V2.5C7.75 1.80964 7.19036 1.25 6.5 1.25H1.5ZM1.75 7.25V2.75H6.25V7.25H1.75Z'
      fill='currentColor'
    />
    <path d='M10 3.75H20V2.25H10V3.75Z' fill='currentColor' />
    <path d='M18 7.75H10V6.25H18V7.75Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.5 11.25C0.809644 11.25 0.25 11.8096 0.25 12.5V17.5C0.25 18.1904 0.809644 18.75 1.5 18.75H6.5C7.19036 18.75 7.75 18.1904 7.75 17.5V12.5C7.75 11.8096 7.19036 11.25 6.5 11.25H1.5ZM1.75 17.25V12.75H6.25V17.25H1.75Z'
      fill='currentColor'
    />
    <path d='M20 13.75H10V12.25H20V13.75Z' fill='currentColor' />
    <path d='M10 17.75H18V16.25H10V17.75Z' fill='currentColor' />
  </Svg>
);

List20.displayName = 'List20';
export default List20;
